import { useSelector } from "react-redux"
import { IStateTree } from "../../interfaces"
import { IUser } from "../models"

export const useUser = () => {
    return useSelector((state: IStateTree) => state.user as IUser)
}